import { render, staticRenderFns } from "./RecruitmentChange.vue?vue&type=template&id=0086a862&scoped=true&"
import script from "./RecruitmentChange.vue?vue&type=script&lang=js&"
export * from "./RecruitmentChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0086a862",
  null
  
)

export default component.exports